<template>
	<div>
		<v-list subheader nopadding margin-top-ten class="listHeaderHasButtons">
			<v-subheader>Fields
				<v-spacer></v-spacer>
				<v-btn flat small color="primary" justify-content-to-end nomargin :ripple="false" @click="openFieldListDialog(true)">Add Field</v-btn>

				<v-menu>
					<v-btn icon flat slot="activator"><v-icon>more_vert</v-icon></v-btn>
			      <v-list nopadding>
			        <v-list-tile @click="openSectionForm">
			          <v-list-tile-title>Add Section</v-list-tile-title>
			        </v-list-tile>
			        <v-divider></v-divider>
			        <v-list-tile @click="openFieldListDialog(true)">
			          <v-list-tile-title>Add Field</v-list-tile-title>
			        </v-list-tile>
			        <v-divider></v-divider>
			        <v-list-tile @click="openReorderSectionDialog" :disabled="fieldItems.length<=1">
			        	<v-list-tile-title>Reorder</v-list-tile-title>
			        </v-list-tile>
			      </v-list>
			    </v-menu>
			</v-subheader>

			<v-divider v-if="fieldItems.length"></v-divider>

			<!-- <Container @drop="applyDrag" class="simple-page" lock-axis="y" drag-handle-selector=".drag-handle">
			<Draggable v-for="(fieldItem, sIndex) in fieldItems" :key="sIndex"> -->
				<v-list v-for="(fieldItem, sIndex) in fieldItems" :key="sIndex" :id="'item_'+fieldItem.section.sectionId" two-line subheader nopadding class="listHeaderHasButtons">
					<v-subheader subheader-dense dark-grey :class="{'light-theme-color': fieldItem.section.isHidden}">{{fieldItem.section.sectionName}} {{fieldItem.section.isHidden ? ' - (Hidden)' : ''}}
						<v-spacer></v-spacer>

						<v-menu>
							<v-btn icon flat slot="activator"><v-icon>more_vert</v-icon></v-btn>
						    <v-list nopadding>
						    	<v-list-tile @click="openFieldListDialog(true, fieldItem.section)" :disabled="fieldItem.section.isHidden">
						        	<v-list-tile-title>Add Field</v-list-tile-title>
						    	</v-list-tile>
						    	<v-divider></v-divider>
						        <v-list-tile @click="editSection(fieldItem.section)" :disabled="fieldItem.section.isHidden">
						        	<v-list-tile-title>Edit Section</v-list-tile-title>
						    	</v-list-tile>
						    	<v-divider></v-divider>
						        <v-list-tile @click="fieldItem.section.isHidden = !fieldItem.section.isHidden">
						        	<v-list-tile-title>{{fieldItem.section.isHidden ? 'Unhide' : 'Hide'}}</v-list-tile-title>
						        </v-list-tile>
						    </v-list>
					    </v-menu>
					</v-subheader>

					<v-divider></v-divider>
					
					<div v-for="(field, fIndex) in fieldItem.fields" :key="fIndex" :id="'item_'+field.transactionTypeFieldId">
						<v-list-tile :class="{'light-theme-color': field.isHidden}" :disabled="fieldItem.section.isHidden">
						  <v-list-tile-content>
						    <v-list-tile-title>{{field.displayName ? field.displayName : field.name}}</v-list-tile-title>
						    <v-list-tile-sub-title>{{fn_getFieldTitle(field.fieldType)}}</v-list-tile-sub-title>
						  </v-list-tile-content>

						  <v-list-tile-action>
						    <v-menu>
								<v-btn icon flat slot="activator"><v-icon>more_vert</v-icon></v-btn>
							    <v-list nopadding>
							        <v-list-tile @click="editField(field, sIndex, fIndex)" :disabled="field.isHidden">
							        	<v-list-tile-title>Edit</v-list-tile-title>
							    	</v-list-tile>
							        <v-divider></v-divider>
							        <v-list-tile :disabled="fn_checkFields(sIndex, fIndex) || field.isHidden" @click="openMoveFieldDialog(sIndex, fIndex)">
							        	<v-list-tile-title>Move</v-list-tile-title>
							        </v-list-tile>
							        <v-divider></v-divider>
							        <v-list-tile @click="field.isHidden = !field.isHidden">
							        	<v-list-tile-title>{{field.isHidden ? 'Unhide' : "Hide"}}</v-list-tile-title>
							        </v-list-tile>
							        <v-divider></v-divider>
							    	<v-list-tile @click="removeField(sIndex, fIndex)" :disabled="field.isHidden">
							        	<v-list-tile-title>Remove</v-list-tile-title>
							    	</v-list-tile>
							    </v-list>
						    </v-menu>
						  </v-list-tile-action>
						</v-list-tile>
						<v-divider v-if="fieldItem.fields.length != fIndex"></v-divider>
					</div>
					
				</v-list>
			<!-- </Draggable>
			</Container> -->
				
		</v-list>
	</div>
</template>

<script>
// import { Container, Draggable } from "vue-smooth-dnd";

	export default{
		// components: { Container, Draggable },
		props:['fieldItems', 'openFieldTypeDialog', 'openFieldListDialog', 'openSectionList', 'openSectionForm', 'comingSoon', 'editField', 'removeField', 'openMoveFieldDialog', 'editSection', 'openReorderSectionDialog'],
		methods: {
			fn_checkFields: function (sIndex, fIndex) {
				let isDisabled = false;
				if(this.fieldItems.length==1){
					if(this.fieldItems[sIndex].fields.length==1 || (this.fieldItems[sIndex].fields.length==2 && fIndex==1)){
						isDisabled = true;
					}
				}
				else{
					for(let i=0;i<this.fieldItems.length;i++){
						if(i!=sIndex){
							if(this.fieldItems[i].fields.length){
								isDisabled = false;
								break;
							}
							else{
								if(this.fieldItems[sIndex].fields.length==1 || 
									(this.fieldItems[sIndex].fields.length==2 && fIndex==1))
								{
									isDisabled = true;
								}
							}
						}
					}
				}
				return isDisabled;
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/fields/fields.vue